import { render, staticRenderFns } from "./PayoneerConnectAccount.vue?vue&type=template&id=d712c20c&scoped=true&"
import script from "./PayoneerConnectAccount.vue?vue&type=script&lang=js&"
export * from "./PayoneerConnectAccount.vue?vue&type=script&lang=js&"
import style0 from "./PayoneerConnectAccount.vue?vue&type=style&index=0&id=d712c20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d712c20c",
  null
  
)

export default component.exports